import { I18nService } from "./i18n.service"
import { flash$ } from "./flash.service"
import { windowScrollTo } from "./dom.service"
import i18nScopedData from './errors.service.yml'

const i18nScoped = new I18nService(i18nScopedData)

export function handleUnknownErrorCode (fullMessages: string[]) {
  return fullMessages.map((msg) => msg === 'unknown_error' ? i18nScoped.t('unknown_error') : msg)
}

export function errorsStateHandler (errorHandler: (this: any, errors: string[]) => void, scrollTopOnError = false) {
  return function <F extends (...args: any[]) => Promise<boolean>>(target: any, propertyKey: string, descriptor: TypedPropertyDescriptor<F>) {
    descriptor.value = errorWrapInHandler(target[propertyKey], errorHandler, scrollTopOnError)
  }
}

export function errorWrapInHandler<T extends (...args: any[]) => Promise<any>> (originalMethod: T, errorHandler: (this: any, errors: string[]) => void, scrollTopOnError = false) {
  return async function (this: any, ...args: any[]) {
    try {
      const originalReturn = await originalMethod.apply(this, args)
      errorHandler.apply(this, [[]])
      return originalReturn
    } catch (err) {
      if (typeof err === 'object' && 'flash' in err) return false // processed into httpParseJsonAndFlash

      const fullMessages = typeof err === 'object' && 'full_messages' in err ? err.full_messages as string[] : null
      errorHandler.apply(this, [fullMessages || ['unknown_error']])
      if (!fullMessages) throw err
      if (scrollTopOnError) windowScrollTo({ top: 0, behavior: 'smooth' })
      return false
    }
  } as any  as T
}

export function errorsSetFlash (errors: string[]) {
  if (!errors.length) return

  const formattedErrors = handleUnknownErrorCode(errors)
    .map(error => error.endsWith('.') ? error : error.concat('.'))
    .join(' ')

  flash$.next({ type: 'error', content: formattedErrors })
}